<template>
  <div class="not-found">
    <h1>404 Page Not Found</h1>
    <div class="logo-falling">
      <img class="logo-e" src="../../static/logo-eosc-synergy-e.png" alt="EOSC synergy">
      <img class="logo-o" src="../../static/logo-eosc-synergy-o.png" alt="EOSC synergy">
      <img class="logo-s" src="../../static/logo-eosc-synergy-s.png" alt="EOSC synergy">
      <img class="logo-c" src="../../static/logo-eosc-synergy-c.png" alt="EOSC synergy">
    </div>
    <h2>Oops! The page you were looking for does not exists</h2>
    <router-link :to="isLogged? '/select-option/' : '/'">
      <div class="link-home">Back to SQAaaS home</div>
    </router-link>
  </div>
</template>

<script>

  import store from "@/store";

  export default {
    computed: {
      isLogged(){
        return store.state.isLogged
      }
    },
  }

</script>

<style scoped>
  .not-found{
    text-align: center;
    padding: max(1em, calc(20vh - 70px)) 0;

    h1{
      color: #FF4A55;
      margin: 15px 5px;
    }

    h2{
      margin-left: 5px;
      margin-right: 5px;
    }

    .logo-falling {
      padding-top: 3em;
      padding-left: 100px;
    }

    .link-home{
      font-size: 1.2em;
      padding-top: 2em;
    }

  }

  .logo-e{
    animation: fall 3s cubic-bezier(.74,.13,.94,.48) 0s forwards;  /* https://cubic-bezier.com/#.74,.13,.94,.48 */
    transform-style: preserve-3d;
    transform-origin: 50% 100%;
  }

  .logo-o{
    position: relative;
    left: -21px;
    top: -31px;
    animation: fall 2s cubic-bezier(.74,.13,.94,.48) 1.5s forwards;
    transform-style: preserve-3d;
    transform-origin: 50% 135%;

  }

  .logo-s{
    position: relative;
    left: -72px;
    top: 8px;
    animation: fall 2.3s cubic-bezier(.74,.13,.94,.48) 1.5s forwards;
    transform-style: preserve-3d;
    transform-origin: 50% 100%;
  }

  .logo-c{
    position: relative;
    left: -100px;
    top: 13px;
    animation: fall 3s cubic-bezier(.74,.13,.94,.48) 0.5s forwards;
    transform-style: preserve-3d;
    transform-origin: 50% 100%;
  }

  @keyframes fall{
      0%{ filter: grayscale(0%); }
     80%{ filter: grayscale(80%) blur(0px);}
    100%{ transform: perspective(250px) rotateX(82deg);
          filter: grayscale(80%) blur(6px); }
  }

</style>
